// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EVlEc{border-radius:16px;height:100%}.xVVMv .jcCat{flex:0 0 288px;min-width:288px}.xVVMv .ltNJS{flex:1 1 0%;min-width:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `EVlEc`,
	"mainLayout": `xVVMv`,
	"sidebar": `jcCat`,
	"steps": `ltNJS`
};
export default ___CSS_LOADER_EXPORT___;
